module.exports = __webpack_public_path__ + "static/media/british-gas-logo.bb66502b.png";